// extracted by mini-css-extract-plugin
module.exports = {"Logo":"-dyqlgtgHI0JfUZMdqTkgQ=="};